/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  /* ===== EM Engraving - cart payload fix =====
   * The engraving script writes flat `properties[...]` fields into the product
   * form, but the form posts the bulk `items[0][...]` format. Shopify silently
   * ignores top-level properties when an items[] array is present, so the
   * engraving text and font never reach the line item.
   * This remaps them to items[0][properties][...] just before the request goes out.
   */
  var PROP_RE = /^properties\[(.+)\]$/;

  function nested(key) {
    return 'items[0][properties][' + key.match(PROP_RE)[1] + ']';
  }

  function remapFormData(fd) {
    var entries = [];
    fd.forEach(function (v, k) { entries.push([k, v]); });
    var isBulk = entries.some(function (e) { return /^items\[\d+\]\[/.test(e[0]); });
    if (!isBulk) return;
    entries.forEach(function (e) {
      if (!PROP_RE.test(e[0])) return;
      fd.delete(e[0]);
      fd.append(nested(e[0]), e[1]);
    });
  }

  function remapString(s) {
    if (s.indexOf('items[0]') === -1 && s.indexOf('items%5B0%5D') === -1) return null;
    var p = new URLSearchParams(s);
    var found = [];
    p.forEach(function (v, k) { if (PROP_RE.test(k)) found.push([k, v]); });
    if (!found.length) return null;
    found.forEach(function (e) { p.delete(e[0]); p.append(nested(e[0]), e[1]); });
    return p.toString();
  }

  function remapJson(s) {
    try {
      var d = JSON.parse(s);
      if (!d || !Array.isArray(d.items) || !d.properties || !d.items[0]) return null;
      d.items[0].properties = Object.assign({}, d.items[0].properties, d.properties);
      delete d.properties;
      return JSON.stringify(d);
    } catch (err) { return null; }
  }

  function isCartAdd(u) { return typeof u === 'string' && u.indexOf('/cart/add') !== -1; }

  var _fetch = window.fetch;
  if (typeof _fetch === 'function') {
    window.fetch = function (input, init) {
      try {
        var url = typeof input === 'string' ? input : (input && input.url) || '';
        if (isCartAdd(url) && init && init.body) {
          if (typeof FormData !== 'undefined' && init.body instanceof FormData) {
            remapFormData(init.body);
          } else if (typeof init.body === 'string') {
            var out = remapString(init.body) || remapJson(init.body);
            if (out) { init = Object.assign({}, init, { body: out }); }
          }
        }
      } catch (err) {}
      return _fetch.call(this, input, init);
    };
  }

  var _open = XMLHttpRequest.prototype.open;
  var _send = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (method, url) {
    this.__emUrl = url;
    return _open.apply(this, arguments);
  };
  XMLHttpRequest.prototype.send = function (body) {
    try {
      if (isCartAdd(this.__emUrl || '') && body) {
        if (typeof FormData !== 'undefined' && body instanceof FormData) {
          remapFormData(body);
        } else if (typeof body === 'string') {
          var out = remapString(body) || remapJson(body);
          if (out) { body = out; }
        }
      }
    } catch (err) {}
    return _send.call(this, body);
  };

  /* Covers the non-AJAX fallback: rename the inputs before a native submit. */
  document.addEventListener('submit', function (ev) {
    try {
      var f = ev.target;
      if (!(f instanceof HTMLFormElement)) return;
      if ((f.getAttribute('action') || '').indexOf('/cart/add') === -1) return;
      if (!f.querySelector('[name^="items["]')) return;
      Array.prototype.forEach.call(f.querySelectorAll('input[name^="properties["]'), function (i) {
        i.name = nested(i.name);
      });
    } catch (err) {}
  }, true);

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
